import { render, staticRenderFns } from "./ReceivedByFNS-ColumnAlphaDaily.vue?vue&type=template&id=0bbb8d84&"
import script from "./ReceivedByFNS-ColumnAlphaDaily.vue?vue&type=script&lang=js&"
export * from "./ReceivedByFNS-ColumnAlphaDaily.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedByFNS-ColumnAlphaDaily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports